export default "__VITE_ASSET__AdX2CyGs__"